import Vue from 'vue'
import VueI18n from 'vue-i18n'

const data = require('./message.json')

Vue.use(VueI18n)

export const defaultLocale = 'en'

// TODO : loceleの設定方法
const i18n = new VueI18n({
  // Use browser first language
  locale: navigator.language.split('-')[0],
  messages: data
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js